/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [批次单汇总信息↗](http://yapi.yishou.com/project/128/interface/api/33612) 的 **请求配置**
 *
 * @分类 [点货单↗](http://yapi.yishou.com/project/128/interface/api/cat_3188)
 * @标签 `采购版4.8.3`
 * @请求头 `POST /erp/pici/info`
 * @更新时间 `2022-05-31 15:42:52`
 */
const infoRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/pici/info",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pici_id"],
        properties: { pici_id: { type: "string", description: "批次单id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            pici_id: { type: "string" },
            pici_no: { type: "string" },
            supply_id: { type: "string" },
            pgid: { type: "string" },
            pici_type: { type: "string" },
            is_box_pici: { type: "string" },
            pici_status: { type: "string" },
            origin: { type: "string" },
            origin_goods_num: { type: "string" },
            goods_num: { type: "string" },
            package_num: { type: "string" },
            pici_img: { type: "array", items: { type: "string" } },
            chayi_remark: { type: "string" },
            chayi_img: { type: "array", items: { type: "string" } },
            create_admin: { type: "string" },
            da_biao_admin: { type: "string" },
            goods_eff_num: { type: "string" },
            goods_inv: { type: "string" },
            goods_diff: { type: "string" },
            no_data_num: { type: "string" },
            storage_chayi: { type: "string" },
            storage_admin: { type: "string" },
            confirm_admin: { type: "null" },
            confirm_time: { type: "string" },
            remark: { type: "string" },
            package_record_id: { type: "string" },
            desk_no: { type: "string" },
            box_no: { type: "string" },
            create_time: { type: "string" },
            update_time: { type: "string" },
            commit_time: { type: "string" },
            in_type: { type: "string" },
            is_no_data_pici: { type: "string" },
            pgname: { type: "string" },
            admin_name: { type: "string" },
            supply_name: { type: "string" },
            package_img: { type: "array", items: { type: "string" } },
            type_txt: { type: "string" },
            status_txt: { type: "string" },
            origin_txt: { type: "string" },
            pici_goods_data: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        origin_goods_num: { type: "string" },
                        goods_num: { type: "string" },
                        goods_eff_num: { type: "string" },
                        goods_inv: { type: "string" },
                        goods_diff: { type: "string" },
                        no_data_num: { type: "string" },
                        no_data_num_goods: { type: "number" },
                        recall_num: { type: "number", tag: "采购版4.8.3", description: "撤标数量" },
                    },
                },
            },
        },
    },
    requestFunctionName: "info",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [批次单汇总信息↗](http://yapi.yishou.com/project/128/interface/api/33612) 的 **请求函数**
 *
 * @分类 [点货单↗](http://yapi.yishou.com/project/128/interface/api/cat_3188)
 * @标签 `采购版4.8.3`
 * @请求头 `POST /erp/pici/info`
 * @更新时间 `2022-05-31 15:42:52`
 */
export const info = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(infoRequestConfig, requestData), ...args);
};
info.requestConfig = infoRequestConfig;
/**
 * 接口 [撤标商品↗](http://yapi.yishou.com/project/128/interface/api/33613) 的 **请求配置**
 *
 * @分类 [点货单↗](http://yapi.yishou.com/project/128/interface/api/cat_3188)
 * @标签 `采购版4.8.3`
 * @请求头 `POST /erp/Pici/getRecallBiao`
 * @更新时间 `2022-05-31 16:07:13`
 */
const getRecallBiaoRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Pici/getRecallBiao",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pici_id", "page", "page_size"],
        properties: {
            pici_id: { type: "string", description: "批次单" },
            page: { type: "string", description: "分页页数" },
            page_size: { type: "string", description: "分页大小" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        dbid: { type: "string", description: "dbid" },
                        dbrid: { type: "string" },
                        pgid: { type: "string", description: "采购组id" },
                        co_val: { type: "string", description: "颜色" },
                        si_val: { type: "string", description: "尺码" },
                        goods_no: { type: "string", description: "商品货号" },
                        create_admin: { type: "string" },
                        create_time: { type: "string", description: "创建时间" },
                        sku: { type: "string" },
                        create_admin_name: { type: "string", description: "创建人" },
                        pgname: { type: "string", description: "采购组名称" },
                        market_price: { type: "string", description: "市场价格" },
                        goods_img: { type: "array", items: { type: "string" }, description: "商品图片" },
                        recall_type: { type: "string", description: "撤标类型" },
                    },
                    required: [
                        "dbid",
                        "dbrid",
                        "pgid",
                        "co_val",
                        "si_val",
                        "goods_no",
                        "create_admin",
                        "create_time",
                        "sku",
                        "create_admin_name",
                        "pgname",
                        "market_price",
                        "goods_img",
                        "recall_type",
                    ],
                },
            },
            count: { type: "number", description: "总大小" },
        },
    },
    requestFunctionName: "getRecallBiao",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [撤标商品↗](http://yapi.yishou.com/project/128/interface/api/33613) 的 **请求函数**
 *
 * @分类 [点货单↗](http://yapi.yishou.com/project/128/interface/api/cat_3188)
 * @标签 `采购版4.8.3`
 * @请求头 `POST /erp/Pici/getRecallBiao`
 * @更新时间 `2022-05-31 16:07:13`
 */
export const getRecallBiao = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getRecallBiaoRequestConfig, requestData), ...args);
};
getRecallBiao.requestConfig = getRecallBiaoRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/pici.js